import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FiCheckCircle, FiAlertCircle } from "react-icons/fi";
import { Spinner } from "../components/ui";
import { verifyEmail } from "../api/auth";
import logo from "../Assets/Images/EMPACT LOGO.png";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("This verification link is missing its token.");
      return;
    }
    verifyEmail(token)
      .then((res) => {
        setStatus("success");
        setMessage(res.data?.message || "Email verified successfully.");
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.response?.data?.message || "This verification link is invalid or has expired.");
      });
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-8 text-center shadow-card">
        <img src={logo} alt="Empact Alumni" className="mx-auto h-9 w-auto" />

        <div className="mt-6">
          {status === "verifying" && (
            <>
              <Spinner className="mx-auto h-8 w-8" />
              <p className="mt-3 text-sm text-slate-500">Verifying your email…</p>
            </>
          )}
          {status === "success" && (
            <>
              <FiCheckCircle className="mx-auto h-10 w-10 text-emerald-500" />
              <p className="mt-3 text-sm text-slate-700">{message}</p>
            </>
          )}
          {status === "error" && (
            <>
              <FiAlertCircle className="mx-auto h-10 w-10 text-red-500" />
              <p className="mt-3 text-sm text-slate-700">{message}</p>
            </>
          )}
        </div>

        <Link to="/dashboard" className="mt-6 inline-block text-sm font-medium text-primary-600 hover:text-primary-700">
          Go to dashboard
        </Link>
      </div>
    </div>
  );
}
